import { render, staticRenderFns } from "./SoldInventoryCapture.vue?vue&type=template&id=5b517b4e&scoped=true"
import script from "./SoldInventoryCapture.vue?vue&type=script&lang=js"
export * from "./SoldInventoryCapture.vue?vue&type=script&lang=js"
import "./SoldInventoryCapture.vue?vue&type=style&index=0&id=5b517b4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b517b4e",
  null
  
)

export default component.exports